import React from 'react';
import PageViewWrapper from 'higherOrder/PageViewWrapper';
import GetStarted from 'components/PublicPages/GetStarted';
import {ServicesPage} from '../../Services.styles';
import { Grid, Row, Col } from '@zendeskgarden/react-grid';

import { variables } from 'theme/variables';

const {
  custom_light_grey,
} = variables;

const TestingAndRepairs = (props) => {

  return (
    <ServicesPage>
    
      <Grid>
        <Row justifyContent="center">
          <Col md={12}>
            <div style={{padding: '40px'}}>
           
            </div>
          </Col>
        </Row>
      </Grid>

      <div style={{background: custom_light_grey}}>
        <GetStarted />
      </div>
    </ServicesPage>
  )
}


export default PageViewWrapper(TestingAndRepairs, {pageName: 'TestingAndRepairs'});
